angular.module('concept-map')
    .directive('lessonGroup', ['$compile', '$document', '$state', 'svgDom', function($compile, $document, $state, svgDom) {
        //
        // This is the event handler for lesson group nodes
        //
        return {
            restrict: 'A',
            scope: {data: "=" },
            link: function (scope, element, attrs) {

                var _element = element; // keep a reference

                var tl_symbol_map = {
                    'W': '#WholeNumStudentCount',
                    'D': '#DecimalsStudentCount',
                    'R': '#RationalStudentCount',
                    'I': '#IntegersStudentCount',
                    'F': '#FractionsStudentCount'
                };

                scope.lessonGroupClick = function () {
                    scope.$parent.lessonGroupClicked(_element.attr("id"));
                    document.getElementById("info-pane").style.height = "140px";
                };

                scope.lessonGroupMouseEnter = function () {
        //          var h = _element.querySelectorAll('.lesson-group-icon')[1];
        //          h.setAttribute('visibility', 'display');
                    console.log('enter');
                };

                scope.lessonGroupMouseLeave = function () {
        //          var h = _element.querySelectorAll('.lesson-group-icon')[1];
        //          h.setAttribute('visibility', 'hidden');
                    console.log('leave');
                };

                element.attr("ng-click", "lessonGroupClick()"); // bind a click handler now
                element.attr("ng-mouseenter", "lessonGroupMouseEnter()"); // bind a mouse handler now
                element.attr("ng-mouseleave", "lessonGroupMouseLeave()"); // bind a mouse handler now
                element.removeAttr("lesson-group");             // remove directive from self to avoid a dead loop
                $compile(element)(scope);

                scope.$watch('data', function(newValue, oldValue, scope) {
                    if (newValue !== undefined) {
                        render(newValue, oldValue, scope);
                    }
                });

                /**
                 * Render a lesson group icon
                 *
                 **/
                var render = function(newValue, oldValue, scope) {
                    var lessonGroupName = _element[0].id;

                    var lessonGroups = scope.$parent.lessonGroups;
                    var viewMode = scope.$parent.viewMode;
                    var lessonGroup = lessonGroups[lessonGroupName];

                    // a hacky way to steal the coordinates of the base icon
                    var anchor = _element.querySelectorAll('circle')[0];
                    var x = anchor.cx.baseVal.value;
                    var y = anchor.cy.baseVal.value;
                    var isEmptyDot = false;

                    if (lessonGroup && lessonGroup.activityData) {

                        var studentCount = viewMode === 'classroom' ? _.size(lessonGroup.activityData.studentIds) : -1;
                        var symbol = tl_symbol_map[lessonGroup.tl];

                        if (symbol !== undefined) {
                            if (studentCount > 0) {
                                symbol += '2';
                            }
                        } else {
                            symbol = '#StudentCounter';
                        }
                        drawLessonGroup(x, y, symbol, studentCount);
                    } else {
                        drawDefaultLessonGroup(x, y);
                        isEmptyDot = true;
                    }

                   // in case debug is on
                    if ($state.params.debug === 'on') {
                      var debugLabel = lessonGroupName;
                      if (lessonGroup !== undefined &&
                          lessonGroup.pdLink !== undefined &&
                          lessonGroup.pdLink.length > 0) {
                         debugLabel += '*';
                      }
                      drawLessonGroupName(x, y, debugLabel, isEmptyDot);
                    }

                }; // end of render

               /**
                 * Rendering functions
                 *
                 **/
                var drawLessonGroup = function(x, y, symbol, studentCount) {
                    var width = studentCount > 0 ? 48 : 36;
                    var offset = width / 2;
                    _element.append(svgDom.createUseNode(x - offset, y - offset, width, width, symbol, 'lesson-group-icon'));

                    if (studentCount > 0) {
                        _element.append(svgDom.createTextNode(x - 14, y, studentCount));
                    }

                  //_element.append(svgDom.createUseNode(x - offset + 20, y - offset + 10, width, width, '#NumberTabTriple', 'lesson-group-icon'));


                };

                var drawDefaultLessonGroup = function(x, y) {
                    var width = 16;
                    var offset = width / 2;
                    _element.append(svgDom.createUseNode(x - offset, y - offset, width, width, '#DotEmpty', 'lesson-group-icon'));
                  //_element.append(svgDom.createUseNode(x - offset -1, y - offset -1, width + 2, width + 2, '#DotEmptyHilite', 'lesson-group-icon'));
                };

                var drawLessonGroupName = function(x, y, lessonGroupName, isEmptyDot) {
                    var offset = isEmptyDot === true ? 10 : 20;
                    _element.append(svgDom.createTextNode(x - offset, y - offset, lessonGroupName));
                };
            }
        };
    }]);
